module.exports = __webpack_public_path__ + "img/智能健康养老设备项目商业计划书_08.ea0c8480.png";